import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createTask } from '../../../redux/actions/SocietyPortal/TaskAction/TaskAction';
import TaskForm from './TaskForm';

const AddTask = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { createTaskLoading } = useSelector((s) => s.TaskReducer);

    const handleSubmit = (payload) => {
        dispatch(createTask({
            ...payload,
            onSuccess: (res) => {
                const id = res?.data?.task_id;
                navigate(id ? `/society-portal/tasks/view/${id}` : '/society-portal/tasks');
            },
        }));
    };

    return <TaskForm mode="add" submitting={createTaskLoading} onSubmit={handleSubmit} />;
};

export default AddTask;
